import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../models/https';
import useHttps from '../useHttps';
import toast from 'react-hot-toast';

const useSendReminder = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onSendReminderError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Failed to send reminder');
  };

  const onSendReminderSuccess = useCallback((response: any) => {
    toast.success(response?.message ?? 'Reminder sent successfully');
  }, []);

  const sendReminder = useCallback(
    (applicationId: string) => {
      const url = `jobs-service/reminders/${applicationId}`;
      const config: HttpConfig = {
        url,
        method: 'post',
      };

      return request(
        config,
        onSendReminderSuccess,
        setLoading,
        onSendReminderError
      );
    },
    [request, onSendReminderSuccess]
  );

  return { sendReminder, loading };
};

export default useSendReminder;
